import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-single-hotel',
    templateUrl: './single-hotel.component.html',
    styleUrls: ['./single-hotel.component.sass']
})
export class SingleHotelComponent implements OnInit {

    constructor() { }

    ngOnInit() {}

}
